import { initFederation } from '@angular-architects/native-federation';

// Just call initFederation() to initialize Native Federation but without
// loading any manifests for remotes. This will be done later, once the
// permissions for the user have been obtained.
initFederation()
  .then(() => import('./bootstrap'))
  .catch(err => console.error(err));
